import { Route } from "vue-router";
import { TenantApiClient } from "@/api/tenant_client";
import store from "@/store";

export const setTenantData = (to: Route, from: Route, next: Function) => {
  const tenantStore = store.state.tenants;
  if (tenantStore && tenantStore.length) {
    next();
  } else {
    new TenantApiClient().listTenants().then(tenants => {
      store.commit("basic", {
        key: "tenants",
        value: tenants
      });
      next();
    });
  }
};

export const setContentData = (to: Route, from: Route, next: Function) => {
  const contentId = to.params.content_id;
  const tenantId = to.params.tenant_id;

  const contentsStore = store.state.contents;
  const contentData = contentsStore[contentId];

  if (contentData) {
    next();
  } else {
    new TenantApiClient().getContent(tenantId, contentId).then(content => {
      store.commit("setContent", {
        id: contentId,
        content: content
      });
      next();
    });
  }
};

export const setUserData = (to: Route, from: Route, next: Function) => {
  const userId = to.params.user_id;
  const tenantId = to.params.tenant_id;

  const userStore = store.state.users;
  const userData = userStore[userId];

  if (userData) {
    next();
  } else {
    new TenantApiClient()
      .getUser(tenantId, userId)
      .then(user => {
        store.commit("setUser", {
          id: userId,
          user: user
        });
        next();
      })
      .catch(error => {
        console.log(error);
      });
  }
};

export const clearBreadcrumbs = (to: Route, from: Route, next: Function) => {
  store.commit("clearBreadcrumbs", true);
  next();
};
